export default "__VITE_ASSET__f37cc6aa__"